import { createSelector } from 'reselect';
import { prop, join, values, without } from 'ramda';

export const getRentalMission = prop('rentalMission');

export const getRentalRegistration = createSelector(
  getRentalMission,
  prop('rentalRegistration'),
);

export const getRentalRegistrationPlateNumber = createSelector(
  getRentalRegistration,
  prop('plateNumber'),
);

export const getRentalRegistrationVinNumber = createSelector(
  getRentalRegistration,
  prop('vinNumber'),
);

export const getRentalRegistrationPhoneNumber = createSelector(
  getRentalRegistration,
  prop('phoneNumber'),
);

export const getRentalDrivers = createSelector(
  getRentalMission,
  prop('rentalDrivers'),
);

export const getRentalVehicleDetails = createSelector(
  getRentalMission,
  prop('rentalVehicleDetails'),
);

export const getRentalBookingDetails = createSelector(
  getRentalMission,
  prop('rentalBookingDetails'),
);

const getRentalVehicleLocationInformation = createSelector(
  getRentalMission,
  prop('rentalVehicleLocation'),
);

export const getRentalVehicleLocation = createSelector(
  getRentalVehicleLocationInformation,
  prop('vehicleLocation'),
);

export const getRentalVehicleOtherLocationType = createSelector(
  getRentalVehicleLocationInformation,
  prop('vehicleLocation'),
);

export const getRentalVehicleOtherLocationAddressObject = createSelector(
  getRentalVehicleLocationInformation,
  prop('garageAddress'),
);

export const getRentalVehicleOtherLocationAddress = createSelector(
  getRentalVehicleOtherLocationAddressObject,
  prop('address'),
);

export const getRentalVehicleOtherLocationFullAddress = createSelector(
  getRentalVehicleOtherLocationAddress,
  address => join(' ', without([undefined], values(address))),
);

export const getRentalVehicleOtherGarageName = createSelector(
  getRentalVehicleLocationInformation,
  prop('garageName'),
);

export const getRentalVehicleOtherGaragePhone = createSelector(
  getRentalVehicleLocationInformation,
  prop('garagePhoneNumber'),
);

export const getRentalVehicleOtherGaragePhoneCountry = createSelector(
  getRentalVehicleLocationInformation,
  prop('phoneCountry'),
);

export const getRentalVehicleOtherGarageEmail = createSelector(
  getRentalVehicleLocationInformation,
  prop('garageEmail'),
);

export const getRentalExtensionDurationInMinutes = createSelector(
  getRentalMission,
  prop('rentalExtensionDurationInMinutes'),
);

export const getRentalExtensionSummaryDisabled = createSelector(
  getRentalMission,
  prop('disableRentalExtensionSummary'),
);
